import { render, staticRenderFns } from "./add-royalty-plan.vue?vue&type=template&id=4081554a&scoped=true&"
import script from "./add-royalty-plan.vue?vue&type=script&lang=js&"
export * from "./add-royalty-plan.vue?vue&type=script&lang=js&"
import style0 from "./add-royalty-plan.vue?vue&type=style&index=0&id=4081554a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4081554a",
  null
  
)

export default component.exports